// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseCustomerFactory instead of class inheritance

import { createBaseCustomer, type IBaseCustomer } from "../BaseCustomerFactory";
import type { FilesInstance } from "./helpers/filesInstanceHelpers";
import { createFilesInstance } from "./helpers/filesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseCustomer, FilesInstance>({
	name: "Files",
	createBase: createBaseCustomer,
	createInstance: createFilesInstance,
});

export function getFilesInstance(): FilesInstance {
	return factory.getInstance();
}
